import { createSlice } from '@reduxjs/toolkit';
import { getLegacyModelos } from '../legacy/thunk.js';

export const initialState = {
    legacyModelos: [],
    loading: false,
    error: {},
};

const legacyModelosSlice = createSlice({
    name: 'legacyModelos',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getLegacyModelos.fulfilled, (state, action) => {
            state.legacyModelos = action.payload;
            state.loading = true;
        });
        builder.addCase(getLegacyModelos.rejected, (state, action) => {
            state.error = action.payload.error || null;
            state.loading = true;
        });
        builder.addCase(getLegacyModelos.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
    }
});

export default legacyModelosSlice.reducer;